module.exports = __webpack_public_path__ + "img/istockphoto-1165926842-612x612.928541d3.jpg";